module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_library.js
// module id = 35
// module chunks = 0